export const logoSizes = {
  xsmall: 36,
  small: 40,
  medium: 120,
  standard: 160
} as const;

export type LogoSize = keyof typeof logoSizes;
